<template>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="资源动作" name="rescAction">
            <swb-com-role-resc-action v-if="activeName == 'rescAction'" :readOnly="readOnly" :bizUnitLevel="bizUnitLevel" :roleId="roleId" :roleName="roleName"></swb-com-role-resc-action>
        </el-tab-pane>
        <el-tab-pane :disabled="!comInfo.postOrgEnabled" label="组织结构" name="org">
            <swb-com-role-org v-if="activeName == 'org'" :readOnly="readOnly" :roleId="roleId" :roleName="roleName"></swb-com-role-org>
        </el-tab-pane>
        <el-tab-pane :disabled="!comInfo.postGoodsCatEnabled" label="商品分类" name="goodsCat">
            <swb-com-role-goods-cat v-if="activeName == 'goodsCat'" :readOnly="readOnly" :roleId="roleId" :roleName="roleName"></swb-com-role-goods-cat>
        </el-tab-pane>
        <el-tab-pane :disabled="!comInfo.postServcCatEnabled" label="服务分类" name="servcCat">
            <swb-com-role-servc-cat v-if="activeName == 'servcCat'" :readOnly="readOnly" :roleId="roleId" :roleName="roleName"></swb-com-role-servc-cat>
        </el-tab-pane>
        <!-- <el-tab-pane :disabled="!comInfo.postIndustryTypeEnabled" label="行业类型" name="industyType">
             <swb-com-role-industy-type v-if="activeName == 'industyType'" :roleId="roleId" :roleName="roleName"></swb-com-role-industy-type>
         </el-tab-pane>
         <el-tab-pane :disabled="!comInfo.postRegionEnabled" label="地区" name="region">
             <swb-com-role-region v-if="activeName == 'region'" :roleId="roleId" :roleName="roleName"></swb-com-role-region>
         </el-tab-pane>-->
    </el-tabs>
</template>

<script>

    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    //
    import servicerAuthxApi from '../../api/servicerAuthx'
    import userApi from '../../api/user'
    import settingApi from '../../api/setting'
    import servicerApi from '../../api/servicer'
    //
    import SwbComRoleRescAction from './ComRoleRescAction';
    Vue.regist(SwbComRoleRescAction);
    import SwbComRoleOrg from './ComRoleOrg';
    Vue.regist(SwbComRoleOrg);
    import SwbComRoleGoodsCat from './ComRoleGoodsCat';
    Vue.regist(SwbComRoleGoodsCat);
    import SwbComRoleServcCat from './ComRoleServcCat';
    Vue.regist(SwbComRoleServcCat);
    import SwbComRoleIndustyType from './ComRoleIndustyType';
    Vue.regist(SwbComRoleIndustyType);
    import SwbComRoleRegion from './ComRoleRegion';
    Vue.regist(SwbComRoleRegion);

    export default {
        name: 'swb-com-role-business-set',
        desc: '公司岗位-业务设置',
        props: {
            comId: {
                type: Number,
                default: null
            },
            roleId: {
                type: Number,
                default: null
            },
            roleName: {
                type: String,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                activeName: 'rescAction',
                comInfo: {
                    postOrgEnabled: false,
                    postRegionEnabled: false,
                    postGoodsCatEnabled: false,
                    postServcCatEnabled: false,
                    postIndustryTypeEnabled: false
                },
                bizUnitLevel: null
            }
        },
        created: function () {
            //
            this.getComInfo();
        },
        methods: {
            handleClick: function (tab, event) {

            },
            getComInfo: function () {
                let self = this;
                let postData = {};
                postData.comId = this.comId;
                servicerApi.getServicerCom(postData, function (result) {
                    if (result.type === 'info') {
                        let comInfo = result.data || {};
                        self.comInfo = comInfo;
                        self.bizUnitLevel = comInfo.bizUnitLevel;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/ComRoleBusinessSet.vue